function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  width: "132%",
  height: "103.9%",
  x: "-16%",
  y: "-1.9%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dx: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0.137254902 0 0 0 0 0.149019608 0 0 0 0.25 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#a)",
  transform: "translate(-26 -762)"
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M36.002 780.011c.034.572.414 1.053.963 1.217l10.166 3.074.373 7.007c.017.278.204.521.47.612a.688.688 0 0 0 .747-.192l3.595-3.98 5.094 3.526c.226.159.492.244.77.244.64 0 1.194-.453 1.33-1.087l4.228-21.55a.694.694 0 0 0-.94-.775l-25.98 10.574c-.527.238-.85.758-.816 1.33zm12.793 9.56l-.232-4.42 2.604 1.8-2.372 2.62zm9.362.538l-9.272-6.419 13.002-12.577-3.73 18.996zm2.304-19.55l-12.855 12.435-10.155-3.068 23.01-9.368z"
}));

var SvgIcNavNotifications = function SvgIcNavNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcNavNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_nav_notifications.61b2e058.svg";
export { ForwardRef as ReactComponent };